import React, { useState, useEffect } from "react";
import { IMAGES } from "../../utils/images";
import "../../Styles/DashboardProfile.css";

const DashboardProfile = () => {
  const [countryEmoji, setCountryEmoji] = useState("🇮🇳");
  const [countryCode, setcountryCode] = useState("+91");
  const [editPersonalinfo, setEditPersonalInfo] = useState(false);
  const [editParentinfo, setEditParentInfo] = useState(false);
  const [editEducationinfo, setEditEducationInfo] = useState(false);
  const [editEmployementinfo, setEditEmployementInfo] = useState(false);
  const [userData, setUserData] = useState(null);
  const [registeredCoursesCount, setRegisteredCoursesCount] = useState(0);

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    name: "",
    email: "",
    about: "Student At SRIM Edutech",
    mobile: "",
    gender: "Male",
    address: "Hyderabad, Telangana",
    maritalstatus: "Single",
    dob: "2025-04-23",
    education: "",
    university: "",
    year: "",
    percentage: "",
    company: "",
    designation: "",
    salary: "",
    experience: "",
  });
  
  useEffect(() => {
    // Get user data from localStorage
    const userDataStr = localStorage.getItem("user");
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        setUserData(userData);
        
        // Set registered courses count
        if (userData.registeredCourses && Array.isArray(userData.registeredCourses)) {
          setRegisteredCoursesCount(userData.registeredCourses.length);
        } else {
          setRegisteredCoursesCount(0);
        }
        
        // Update form data with user information
        if (userData.fullName) {
          const nameParts = userData.fullName.split(' ');
          setFormData(prevData => ({
            ...prevData,
            firstname: nameParts[0] || "",
            lastname: nameParts.slice(1).join(' ') || "",
            email: userData.email || "",
            mobile: userData.mobile ? `+91 ${userData.mobile}` : ""
          }));
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log(formData);
  };
  const handleCountry = (code, emoji) => {
    setCountryEmoji(emoji);
    formData.country = code;
    console.log(formData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData({
      firstname: "",
      lastname: "",
      name: "",
      email: "",
      about: "",
      mobile: "",
      gender: "",
      address: "",
      maritalstatus: "",
      dob: "",
      education: "",
      university: "",
      year: "",
      percentage: "",
      company: "",
      designation: "",
      salary: "",
      experience: "",
    });
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="dashboard-content">
      <div className="profile-heading-container">
        <img src={IMAGES.DASHBOARD_FRAME_PROFILE} />
        <div>
          <h1 className="heading-text-h1">{userData ? userData.fullName : "User"}</h1>
          <p className="heading-text-p">Student at SRIM Edutech</p>
          <p className="heading-text-p">Registered Courses: {registeredCoursesCount}</p>
        </div>
      </div>
      <hr className="dashboard-home-hr" />

      <div className="info-container">
        <div className="profile-personal-container">
          <h2 className="personal-heading">Personal Information</h2>
          {editPersonalinfo ? (
            <button
              onClick={() => setEditPersonalInfo(false)}
              className="save-btn"
            >
              Save
            </button>
          ) : (
            <button
              className="edit-btn"
              onClick={() => setEditPersonalInfo(true)}
            >
              Edit
              <img src={IMAGES.EDIT_ICON} />
            </button>
          )}
        </div>

        <div className="info-form-container">
          <div id="input-container-form">
            <label id="input-label">First Name:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              placeholder="First Name"
              onClick={stopPropagation}
              required
            />
          </div>
          <div id="input-container-form">
            <label id="input-label">Last Name:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
              placeholder="Last Name"
              onClick={stopPropagation}
              required
            />
          </div>
          <div id="input-container-form">
            <label id="input-label">Email Address:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">About:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="about"
              value={formData.about}
              onChange={handleChange}
              placeholder="about"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Phone:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Mobile Number"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Alternative Phone:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Mobile Number"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Gender:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Date Of Birth:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Address:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Marital Status:</label>
            <input
              id={editPersonalinfo ? "input" : "input-form"}
              type="text"
              name="maritalstatus"
              value={formData.maritalstatus}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>
        </div>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="info-container">
        <div className="profile-personal-container">
          <h2 className="personal-heading">Parent Information</h2>
          {editParentinfo ? (
            <button
              onClick={() => setEditParentInfo(false)}
              className="save-btn"
            >
              Save
            </button>
          ) : (
            <button
              className="edit-btn"
              onClick={() => setEditParentInfo(true)}
            >
              Edit
              <img src={IMAGES.EDIT_ICON} />
            </button>
          )}
        </div>

        <div className="info-form-container">
          <div id="input-container-form">
            <label id="input-label">Name:</label>
            <input
              id={editParentinfo ? "input" : "input-form"}
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Email Address:</label>
            <input
              id={editParentinfo ? "input" : "input-form"}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Phone:</label>
            <input
              id={editParentinfo ? "input" : "input-form"}
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Mobile Number"
              onClick={stopPropagation}
              required
            />
          </div>
        </div>
      </div>

      <hr className="dashboard-home-hr" />

      <div className="info-container">
        <div className="profile-personal-container">
          <h2 className="personal-heading">Education Information</h2>
          {editEducationinfo ? (
            <button
              onClick={() => setEditEducationInfo(false)}
              className="save-btn"
            >
              Save
            </button>
          ) : (
            <button
              className="edit-btn"
              onClick={() => setEditEducationInfo(true)}
            >
              Edit
              <img src={IMAGES.EDIT_ICON} />
            </button>
          )}
        </div>

        <div className="info-form-container">
          <div id="input-container-form">
            <label id="input-label">Education:</label>
            <input
              id={editEducationinfo ? "input" : "input-form"}
              type="text"
              name="education"
              value={formData.education}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">University:</label>
            <input
              id={editEducationinfo ? "input" : "input-form"}
              type="text"
              name="university"
              value={formData.university}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Year:</label>
            <input
              id={editEducationinfo ? "input" : "input-form"}
              type="text"
              name="year"
              value={formData.year}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Percentage:</label>
            <input
              id={editEducationinfo ? "input" : "input-form"}
              type="text"
              name="percentage"
              value={formData.percentage}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>
        </div>
      </div>

      <hr className="dashboard-home-hr" />

      <div className="info-container">
        <div className="profile-personal-container">
          <h2 className="personal-heading">Employment Information </h2>
          {editEmployementinfo ? (
            <button
              onClick={() => setEditEmployementInfo(false)}
              className="save-btn"
            >
              Save
            </button>
          ) : (
            <button
              className="edit-btn"
              onClick={() => setEditEmployementInfo(true)}
            >
              Edit
              <img src={IMAGES.EDIT_ICON} />
            </button>
          )}
        </div>

        <div className="info-form-container">
          <div id="input-container-form">
            <label id="input-label">Employment Status:</label>
            <input
              type="checkbox"
              id="Accept_Privacy"
              name="Privacy"
              value="Checked"
            ></input>
            <label htmlFor="Accept_Privacy" className="check-text">
              Employed
            </label>
          </div>
          <div id="input-container-form">
            <label id="input-label">Company:</label>
            <input
              id={editEmployementinfo ? "input" : "input-form"}
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Designation:</label>
            <input
              id={editEmployementinfo ? "input" : "input-form"}
              type="text"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Salary:</label>
            <input
              id={editEmployementinfo ? "input" : "input-form"}
              type="text"
              name="salary"
              value={formData.salary}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>

          <div id="input-container-form">
            <label id="input-label">Experience:</label>
            <input
              id={editEmployementinfo ? "input" : "input-form"}
              type="text"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              placeholder=""
              onClick={stopPropagation}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardProfile;
